'use client';

// wrapper for https://mui.com/material-ui/react-slider/

import * as React from 'react';
import { Slider as SliderPrimitive } from '@mui/material';

import { ComponentProps, useMemo } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import styles from './slider.module.scss';
import { Mark } from '@mui/material/Slider/useSlider.types';

const sliderClass = cva(styles.slider, {
  variants: {},
  defaultVariants: {}
});

type SliderProps = ComponentProps<'div'> & VariantProps<typeof sliderClass>;

const generateLargeMarkStyling = (marks?: Mark[] | boolean) => {
  return Array.isArray(marks)
    ? marks.reduce((styleObject, mark, index) => {
        if (mark.label) {
          return {
            ...styleObject,
            [`& .MuiSlider-mark[data-index="${index}"]`]: {
              width: '1.25rem',
              height: '1.25rem'
            }
          };
        }
        return styleObject;
      }, {})
    : {};
};

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive> &
    SliderProps & {
      onChange?: (value: number | number[]) => void;
    }
>(({ marks, onChange, ...props }, ref) => {
  const largeMarkStyling = useMemo(
    () => generateLargeMarkStyling(marks),
    [marks]
  );

  return (
    <div className={styles.container}>
      <SliderPrimitive
        ref={ref}
        className={sliderClass(styles.popover)}
        marks={marks}
        sx={largeMarkStyling}
        onChange={(_, value) => {
          onChange?.(value);
        }}
        {...props}
      />
    </div>
  );
});

Slider.displayName = 'Slider';

export default Slider;
